import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'orderDateOptionMixin'
})
export default class extends Vue {
  protected queryForm: any = {
    start_time: null,
    end_time: null,
    notify_start_time: null,
    notify_end_time: null,
    success_start_time: null,
    success_end_time: null
  }
  protected date: any[] = getCurrentDate()
  protected successDate: any[] = []
  protected notifyDate: any[] = []

  protected pickerOptions = pickerOptions
  protected dateType: string = 'Created Time'

  protected dateChange (e) {
    if (e === 'Notify Time') {
      this.notifyDate = getCurrentDate()
      this.pickerChange2()
    } else if (e === 'Success Time') {
      this.successDate = getCurrentDate()
      this.successTimeChange()
    } else if (e === 'Created Time') {
      this.date = getCurrentDate()
      this.pickerChange()
    } else if (e === 'All Time') {
      this.date = getCurrentDate()
      this.successDate = []
      this.allTimeQuery()
    }
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  protected pickerChange () {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
      this.queryForm.success_start_time = null
      this.queryForm.success_end_time = null
      this.queryForm.notify_start_time = null
      this.queryForm.notify_end_time = null
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  // 通知时间监听
  protected pickerChange2 () {
    if (this.notifyDate) {
      this.queryForm.notify_start_time = dateToSeconds(this.notifyDate[0])
      this.queryForm.notify_end_time = dateToSeconds(this.notifyDate[1])
      this.queryForm.start_time = null
      this.queryForm.end_time = null
      this.queryForm.success_start_time = null
      this.queryForm.success_end_time = null
    } else {
      this.queryForm.notify_start_time = null
      this.queryForm.notify_end_time = null
    }
  }

  // 成功时间
  protected successTimeChange () {
    if (this.successDate) {
      this.queryForm.success_start_time = dateToSeconds(this.successDate[0])
      this.queryForm.success_end_time = dateToSeconds(this.successDate[1])
      this.queryForm.notify_start_time = null
      this.queryForm.notify_end_time = null
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    } else {
      this.queryForm.success_start_time = null
      this.queryForm.success_end_time = null
    }
  }

  // 统合时间查询
  protected allTimeQuery () {
    this.queryForm.start_time = dateToSeconds(this.date[0])
    this.queryForm.end_time = dateToSeconds(this.date[1])
    this.queryForm.success_start_time = dateToSeconds(this.successDate[0])
    this.queryForm.success_end_time = dateToSeconds(this.successDate[1])
  }
}
